import { ChangeEvent, useCallback, useId } from 'react';
import { BorderRadius } from 'apps/cdp-web-demo/app/types';
import { ControlGroup } from '@cbhq/cds-web/controls/ControlGroup';
import { Text } from '@cbhq/cds-web/typography';

import styles from './BorderRadius.module.css';
import { Radio as BorderRadiusRadio } from './BorderRadiusRadioInput';

type Props = {
  setBorderRadius: (borderRadius: BorderRadius) => void;
  borderRadius: BorderRadius | undefined;
};

const borderRadiusOptions: {
  name: string;
  label: string;
  value: BorderRadius;
  'aria-label': string;
}[] = [
  {
    label: '–',
    name: 'borderRadius',
    'aria-label': 'none',
    value: 'none',
  },
  {
    label: 'S',
    name: 'borderRadius',
    'aria-label': 'small',
    value: 'sm',
  },
  {
    label: 'M',
    name: 'borderRadius',
    'aria-label': 'medium',
    value: 'md',
  },
  {
    label: 'L',
    name: 'borderRadius',
    'aria-label': 'large',
    value: 'lg',
  },
  {
    label: 'XL',
    name: 'borderRadius',
    'aria-label': 'extra large',
    value: 'xl',
  },
];

function BorderRadiusField({ setBorderRadius, borderRadius }: Props) {
  const labelId = useId();

  const handleBorderRadiusChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setBorderRadius(e.target.value as BorderRadius);
    },
    [setBorderRadius],
  );

  return (
    <ControlGroup
      label={
        <Text id={labelId} font="label1" paddingY={0.5} className={styles['radio-label']}>
          Border radius
        </Text>
      }
      aria-labelledby={labelId}
      columnGap={1}
      ControlComponent={BorderRadiusRadio}
      value={borderRadius ?? ''}
      role="radiogroup"
      onChange={handleBorderRadiusChange}
      options={borderRadiusOptions}
      className={styles['radio-group']}
    />
  );
}

export { BorderRadiusField };
